import { render } from "./WelcomeWrapper.vue?vue&type=template&id=eb6fc8b0"
import script from "./WelcomeWrapper.vue?vue&type=script&lang=js"
export * from "./WelcomeWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__